export default [0, 502, 504, 511];
